import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getAllCourseClass = para => requestActionMaker({ cons: cons.GET_ALL_COURSE_CLASS, api: apis.getAllCourseClass, ...para });
export const getCourseClass = para => requestActionMaker({ cons: cons.GET_COURSE_CLASS, api: apis.getCourseClass, ...para });